import { render, staticRenderFns } from "./ObiCardMetric.vue?vue&type=template&id=5e4a2cac&scoped=true&"
import script from "./ObiCardMetric.vue?vue&type=script&lang=js&"
export * from "./ObiCardMetric.vue?vue&type=script&lang=js&"
import style0 from "./ObiCardMetric.vue?vue&type=style&index=0&id=5e4a2cac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4a2cac",
  null
  
)

export default component.exports